import * as z from 'zod'
import { DriverRegistrationRequest } from '~/shared/api'
import { Option } from '~/shared/config/constants'

export const formSchema = DriverRegistrationRequest.schema.pick({
  lastName: true,
  firstName: true,
  middleName: true,
  phone: true,
  email: true,
  regionCode: true,
  placeOfResidence: true,
  snils: true,
  birthPlace: true,
  photo: true,
  infoSource: true,
})

export type SchemaType = z.infer<typeof formSchema>

export type FormValues = Omit<SchemaType, 'regionCode'> & {
  regionCode: Option | UniqueId
}
